import React, { useEffect, useState } from 'react'
import Box from '@/components/boxes/Box'

interface TimeLeft {
    hours: number
    minutes: number
    seconds: number
}

const CountdownTimer: React.FC<{ auctionDate: Date }> = ({ auctionDate }) => {
    const calculateTimeLeft = (): TimeLeft | undefined => {
        const now: Date = new Date()
        const futureDate = new Date(auctionDate)

        if (isNaN(futureDate.getTime())) {
            return undefined
        }

        const diff: number = futureDate.getTime() - now.getTime()

        if (diff <= 0) {
            return { hours: 0, minutes: 0, seconds: 0 }
        }

        const hours: number = Math.floor(diff / (1000 * 60 * 60))
        const minutes: number = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds: number = Math.floor((diff % (1000 * 60)) / 1000)

        return { hours, minutes, seconds }
    }

    const [timeLeft, setTimeLeft] = useState<TimeLeft | undefined>(calculateTimeLeft)

    useEffect(() => {
        const intervalId = setInterval(() => {
            const newTimeLeft = calculateTimeLeft()
            setTimeLeft(newTimeLeft)
            if (!newTimeLeft || (newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0)) {
                clearInterval(intervalId)
            }
        }, 1000)

        return () => clearInterval(intervalId)
    }, [auctionDate])

    return (
        <Box
            caption={'Auction End'}
            text={!timeLeft ? 'Halted' : timeLeft.hours + 'h ' + timeLeft.minutes + 'm ' + timeLeft.seconds + 's'}
            triggerAnimation={false}
        />
    )
}

export default CountdownTimer
